module.exports = __webpack_public_path__ + "static/media/na.5817eb6b.svg";